<template>
  <div class="container-register-kit">
    <h4>Agora falta pouco!</h4>
    <h5>Preencha os campos a seguir para conhecermos mais sobre você.</h5>
    <p>É rápido, seguro, e você já começa a ter mais saúde.</p>

    <h4>Dados Pessoais</h4>

    <form @submit="handleSubmit" class="form">
      <div class="input-box">
        <label for="cpf">CPF</label>
        <input
          type="text"
          name="cpf"
          id="cpf"
          v-model="form.cpf"/>
        <small class="error" v-if="errors && errors.cpf">{{errors.cpf.join()}}</small>
      </div>
      <div class="input-box">
        <label for="name">Nome Completo</label>
        <input
          type="text"
          name="name"
          id="name"
          v-model="form.name"/>
        <small class="error" v-if="errors && errors.name">{{errors.name.join()}}</small>
      </div>
      <div class="input-box">
        <label for="gender">Sexo</label>
        <select
          name="gender"
          id="gender"
          v-model="form.gender">
          <option value=null>Selecione uma opção</option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
          <option value="O">Outro</option>
        </select>
        <small class="error" v-if="errors && errors.gender">{{errors.gender.join()}}</small>
      </div>
      <div class="input-box">
        <label for="ethnicity">Etnia</label>
        <select
          name="ethnicity"
          id="ethnicity"
          v-model="form.ethnicity">
          <option value=null>Selecione uma opção</option>
          <option value="A">Amarelo</option>
          <option value="B">Branco</option>
          <option value="I">Indígena</option>
          <option value="M">Mestiço</option>
          <option value="N">Negro</option>
          <option value="P">Pardo</option>
        </select>
        <small class="error" v-if="errors && errors.ethnicity">{{errors.ethnicity.join()}}</small>
      </div>
      <button class="button btn-primary" v-if="!loading" @click="handleSubmit">Salvar e Próximo</button>
      <button class="button btn-primary" v-if="loading" @click="handleSubmit" disabled><loading /></button>
    </form>
  </div>
</template>

<script>
  export default {
    props: ['next'],
    name: "DataKitCustomer",
    data: () => ({
      loading: false,
      errors: [],
      form: {
        cpf: "",
        ethnicity: "",
        gender: "",
        name: ""
      }
    }),
    methods: {
      handleSubmit(event) {
        event.preventDefault();
        this.$emit('next', this.form);
      }
    }
  }
</script>

<style scoped>
  .container-register-kit {
    max-width: 480px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/DataKitCustomer.vue